import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const selectedSize = product?.size?.[0] || "";
  const selectedColor = product?.colors?.[0] || "";
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeTab, setActiveTab] = useState("details");

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <div className="product-detail-container">
        <div className="product-gallery">
          <div className="main-image">
            <img src={product.images[selectedImage]} alt={product.name} />
          </div>
          <div className="thumbnail-images">
            {product.images.map((img, idx) => (
              <button
                key={idx}
                className={`thumbnail ${selectedImage === idx ? "active" : ""}`}
                onClick={() => setImage(idx)}
              >
                <img src={img} alt={`${product.name} ${idx + 1}`} />
              </button>
            ))}
          </div>
        </div>

        <div className="product-info">
          <div className="breadcrumb">
            <Link to="/" onClick={toTop}>
              Home
            </Link>
            <span> / </span>
            <Link to="/shop" onClick={toTop}>
              all
            </Link>
          </div>

          <h1 className="product-title">{product.name}</h1>

          <div className="product-rating">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="star">
                  ★
                </span>
              ))}
            </div>
            <span className="review-count">{product.reviews} reviews</span>
          </div>

          <div className="product-features-list">
            <div className="feature-item">
              <span className="feature-icon">🌏</span>
              <span>Original Design</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">⚪</span>
              <span>{product.material}</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">💧</span>
              <span>Care Details Listed</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Multiple Product Views</span>
            </div>
          </div>

          <div className="product-tabs">
            <button
              className={`tab ${activeTab === "details" ? "active" : ""}`}
              onClick={() => setActiveTab("details")}
            >
              Details
            </button>
            <button
              className={`tab ${activeTab === "material" ? "active" : ""}`}
              onClick={() => setActiveTab("material")}
            >
              Features
            </button>
          </div>

          <div className="tab-content">
            {activeTab === "details" && (
              <div className="details-content">
                {product.description.map((des, index) => (
                  <p key={index}>{des}</p>
                ))}
              </div>
            )}
            {activeTab === "material" && (
              <div className="material-content">
                {product.Features.map((fea, index) => (
                  <li key={index}>{fea}</li>
                ))}
              </div>
            )}
          </div>

          <div className="product-price">
            <span className="price">€{product.price}</span>
          </div>

          <div className="stock-status">
            <span className="in-stock-icon">🟢</span>
            <span>In stock, ready to ship</span>
          </div>

          <div className="add-to-cart-section">
            <button className="add-to-cart-btn" onClick={handleAddToCart}>
              Add to cart
            </button>
          </div>

          <div className="shipping-info">
            <div className="shipping-header">
              <span>Shipping</span>
            </div>
            <div className="shipping-content">
              <p>
                Available delivery methods, charges, and estimates are shown at
                checkout for the destination entered.
              </p>
              <p>Orders are prepared after payment confirmation.</p>
              <p>Tracking details are sent when available after dispatch.</p>
              <p>
                International customers are responsible for any import duties,
                taxes, or fees charged by the destination country.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
